import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { MaterialModule } from "../../components/material/material.module";
import { UsuarioService } from "../../providers/usuario.service";
import { CrearUsuarioComponent } from "./crear-usuario/crear-usuario.component";
import { CrearUsuarioDialog } from "./crear-usuario/crear-usuario-dialog/crear-usuario-dialog.component";
import { EditarUsuarioComponent } from "./editar-usuario/editar-usuario.component";
import { EditarUsuarioDialog } from "./editar-usuario/editar-usuario-dialog/editar-usuario-dialog.component";
import { EstadoUsuarioComponent } from "./estado-usuario/estado-usuario.component";
import { EstadoUsuarioDialog } from "./estado-usuario/estado-usuario-dialog/estado-usuario-dialog.component";
import { UsuarioComponent } from "./usuario/usuario.component";
import { VerUsuariosComponent } from "./ver-usuarios/ver-usuarios.component";
import { TelefonoModule } from "../../components/telefono/telefono.module";
import { AutorizadorModule } from "../../components/autorizador/autorizador.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
        TelefonoModule,
        AutorizadorModule,
    ],
    declarations: [
        CrearUsuarioComponent,
        CrearUsuarioDialog,
        EditarUsuarioComponent,
        EditarUsuarioDialog,
        EstadoUsuarioComponent,
        EstadoUsuarioDialog,
        UsuarioComponent,
        VerUsuariosComponent,
    ],
    providers: [
        UsuarioService
    ],
    entryComponents: [
        CrearUsuarioDialog,
        EditarUsuarioDialog,
        EstadoUsuarioDialog,
    ],
    exports: [
        CrearUsuarioComponent,
        EditarUsuarioComponent,
        EstadoUsuarioComponent,
        UsuarioComponent,
        VerUsuariosComponent,
    ]
})
export class UsuarioModule { }